export const administrationAccountsRooms = {
    template: require('./administration-accounts-rooms.html'),
    controller: 'AdministrationAccountsRoomsController'
};
